import React from 'react';
import { formatWikiTime } from '../../wiki.date';

const labels = {
  dirty: 'Modifications non enregistrées',
  saving: 'Sauvegarde...',
  saved: 'Enregistré',
  error: 'Échec de la sauvegarde',
  conflict: 'Conflit de version',
};

const formatSavedAt = (value) => {
  if (!value) {
    return '';
  }

  const time = formatWikiTime(value);
  return time ? `Enregistré à ${time}` : '';
};

function WikiEditorStatus({ characterCount = 0, error = '', savedAt, state = 'saved' }) {
  const savedLabel = formatSavedAt(savedAt) || labels[state] || labels.saved;

  return (
    <div className={`wiki-editor-status ${state}`}>
      <span>{state === 'saved' ? savedLabel : labels[state]}</span>
      {error && <strong>{error}</strong>}
      <small>{characterCount} caractères</small>
    </div>
  );
}

export default WikiEditorStatus;
